$(document).ready(function() {
  $("#welcomeModal").modal("show");
});
